import axios from "axios";

// const communityapi = axios.create({
//   baseURL: "http://localhost:8082",
// });

const communityapi = axios.create({
  baseURL: "http://172.31.12.209:8082",
});

communityapi.interceptors.request.use((config) => {
  // const token = localStorage.getItem("jwt");
  const auth = JSON.parse(

    localStorage.getItem("auth")

  );

  const token = auth?.accessToken;
  // if (!token) {
  //   window.location.href = "/authlogin"; // redirect
  //   console.warn("No token found, redirecting to login");
  //   return Promise.reject("No token");
  // }
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default communityapi;